import React, {Component} from 'react';
import {Link} from "react-router-dom";
import { render } from 'react-dom';
import Header from "./header";
import Footer from "./footer";
import moment from 'moment';
import { Responsive, Container, Grid, Image, Pagination } from 'semantic-ui-react';

import axios from 'axios';
import "react-treeview/react-treeview.css"
import Config from '../../config';
import Gallery from 'react-grid-gallery';

const now = moment();

const ROOT_URL = Config.ROOT_URL;
class PhotoDetails extends Component {

    constructor(props){
        super(props);
        this.state = {
            album:undefined,
            dataWithPagination:{
                data:[],
                // page:1,
                // totalPages:1,
            },
        };
      }

    componentDidMount() {
        console.log('hihi',this.props);
        const id = this.props.match.params.photoId;
        axios.get(`${ROOT_URL}/album/${id}`)
        .then(res => {
            const results = res.data;
            this.setState({
                album:results.data,
            })
            console.log('album',results.data);
        });
        this.fetchData(1);
    }

    fetchData(page) {
        const id = this.props.match.params.photoId;
        axios.get(`${ROOT_URL}/albumMedia/album/${id}?page=${page}`)
        .then(res => {
            const results = res.data;
            this.setState({
                dataWithPagination:results
            })
            console.log(results);
        });
    }
    

    render() {
        const {dataWithPagination, album} = this.state;
        const images = dataWithPagination.data.map((item)=>{
            // console.log('item', item);
            return {
                src: item.baseUrl,
                thumbnail: item.baseUrl,
            }
        });
        return (
          <div className="Homepage">
            <Header page="aboutus" />
            <div className="homeContentWhite">
              <div className="homeContent">
    
                <Container>
                 <h1>{album && album.title ? album.title : ''}</h1>
                 <div>
                  {
                    // dataWithPagination.data.map((item)=>{
                    //     console.log('item', item);
                    //   return (
                    //     <img src={item.baseUrl}></img>
                    //   )
                    // })
                  }
                  <Gallery images={images}/>
                 </div>
                 {
                    // <div className="margin_top_m">
                    //     <Pagination
                    //         defaultActivePage={1}
                    //         totalPages={dataWithPagination.totalPages}
                    //         onPageChange={(event, paginationData)=>{
                    //             const activePage = paginationData.activePage;
                    //             this.fetchData(activePage);
                    //         }}
                    //     />
                    // </div>
                 }
           
                </Container>
              </div>
            </div>
            <Footer />
          </div>
        );
      }
}

export default PhotoDetails;

/*
*/
